(function () {
    "use strict";

    document.addEventListener("DOMContentLoaded", function () {

        const container = document.getElementById("ankur-community-reviews");

        if (!container || typeof window.ACR_DATA === "undefined") return;

        const productId = parseInt(container.dataset.productId, 10);
        const productTitle = container.dataset.productTitle;
        const reviewList = container.querySelector(".acr-review-list");

        // --------------------------------------------------
        // Seeded Random Generator
        // --------------------------------------------------

        function mulberry32(seed) {
            return function () {
                let t = seed += 0x6D2B79F5;
                t = Math.imul(t ^ t >>> 15, t | 1);
                t ^= t + Math.imul(t ^ t >>> 7, t | 61);
                return ((t ^ t >>> 14) >>> 0) / 4294967296;
            };
        }

        const random = mulberry32(productId);

        function pickUnique(array, used) {

            if (used.size >= array.length) {
                used.clear();
            }

            let index;

            do {
                index = Math.floor(random() * array.length);
            }
            while (used.has(index));

            used.add(index);

            return array[index];
        }

        // --------------------------------------------------
        // Used indexes
        // --------------------------------------------------

        const usedNames = new Set();
        const usedEnglish = new Set();
        const usedHinglish = new Set();
        const usedShort = new Set();
        const usedHindi = new Set();
        const usedLongEnglish = new Set();
        const usedLongHindi = new Set();
        const usedLongHinglish = new Set();
        const usedOneStar = new Set();
        const usedTwoStar = new Set();
        // --------------------------------------------------
        // Number of reviews
        // --------------------------------------------------

        let TOTAL_REVIEWS;

        const reviewSeed = random();

        if (reviewSeed < 0.25) {
            // 25% of products
            TOTAL_REVIEWS = 0;
        }
        else if (reviewSeed < 0.40) {
            // Next 15%
            TOTAL_REVIEWS = 1;
        }
        else if (reviewSeed < 0.50) {
            // Next 10%
            TOTAL_REVIEWS = 2;
        }
        else if (reviewSeed < 0.58) {
            // Next 8%
            TOTAL_REVIEWS = 3;
        }
        else if (reviewSeed < 0.65) {
            // Next 7%
            TOTAL_REVIEWS = 4;
        }
        else if (reviewSeed < 0.71) {
            // Next 6%
            TOTAL_REVIEWS = 5;
        }
        else if (reviewSeed < 0.76) {
            // Next 5%
            TOTAL_REVIEWS = 6;
        }
        else if (reviewSeed < 0.81) {
            // Next 5%
            TOTAL_REVIEWS = 7;
        }
        else if (reviewSeed < 0.85) {
            // Next 4%
            TOTAL_REVIEWS = 8;
        }
        else if (reviewSeed < 0.89) {
            // Next 4%
            TOTAL_REVIEWS = 10;
        }
        else if (reviewSeed < 0.92) {
            // Next 3%
            TOTAL_REVIEWS = 12;
        }
        else if (reviewSeed < 0.95) {
            // Next 3%
            TOTAL_REVIEWS = 15;
        }
        else if (reviewSeed < 0.97) {
            // Next 2%
            TOTAL_REVIEWS = 18;
        }
        else if (reviewSeed < 0.99) {
            // Next 2%
            TOTAL_REVIEWS = 20;
        }
        else {
            // Final 1%
            TOTAL_REVIEWS = 25;
        }
        const reviewDates = [
            "Yesterday",
            "1 day ago",
            "2 days ago",
            "4 days ago",
            "6 days ago",
            "1 week ago",
            "2 weeks ago",
            "3 weeks ago",
            "1 month ago",
            "2 months ago",
            "3 months ago",
            "4 months ago",
            "5 months ago",
            "7 months ago",
            "9 months ago",
            ];
            const reviewPools = [

            {
                array: ACR_DATA.longHindiReviews,
                used: usedLongHindi
            },

            {
                array: ACR_DATA.englishReviews,
                used: usedEnglish
            },

            {
                array: ACR_DATA.longHinglishReviews,
                used: usedLongHinglish
            },

            {
                array: ACR_DATA.shortReviews,
                used: usedShort
            },

            {
                array: ACR_DATA.longEnglishReviews,
                used: usedLongEnglish
            },

            {
                array: ACR_DATA.hindiReviews,
                used: usedHindi
            },

            {
                array: ACR_DATA.hinglishReviews,
                used: usedHinglish
            }

        ];    
        reviewPools.sort(function () {

        return random() - 0.5;

        });
            let html = "";

        for (let i = 0; i < TOTAL_REVIEWS; i++) {

            const firstName = pickUnique(
            ACR_DATA.names,
            usedNames
            );

            const lastName = pickUnique(
                ACR_DATA.lastNames,
                new Set()
            );

        const name = `${firstName} ${lastName}`;
            const city =
                ACR_DATA.cities[
                    Math.floor(random() * ACR_DATA.cities.length)
                ];

            const date = reviewDates[i];

            const rating =
                ACR_DATA.ratings[
                    Math.floor(random() * ACR_DATA.ratings.length)
                ];

            let template;

            // ==================================================
            // 1★ & 2★ → Negative Review Library
            // 3★, 4★ & 5★ → Normal Review Pools
            // ==================================================

            if (rating <= 2) {

                const negativePool = ACR_DATA.negativeReviews.filter(function (review) {
                    return review.severity === rating;
                });

                template = pickUnique(
                    negativePool,
                    rating === 1 ? usedOneStar : usedTwoStar
                ).text;

            } else {

                // Pick a random review category

                const pool =
                    reviewPools[
                        Math.floor(random() * reviewPools.length)
                    ];

                template = pickUnique(
                    pool.array,
                    pool.used
                );

            }

            const review = template.replace(
                /\{product\}/g,
                productTitle
            );

            let stars = "";

            for (let s = 0; s < rating; s++) {
                stars += "★";
            }

            if (rating === 4) {
                stars += "☆";
            }
            if (rating === 3) {
                stars += "☆☆";
            }
            if (rating === 2) {
                stars += "☆☆☆";
            }
            if (rating === 1) {
                stars += "☆☆☆☆";
            }

            html += `

<div class="acr-review-card">

        <div class="acr-top">

        <div class="acr-user">

            <div class="acr-avatar">
                ${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}
            </div>

            <div class="acr-name">
                ${name}
            </div>

        </div>

        <div class="acr-stars">
            ${stars}
        </div>

    </div>

    <div class="acr-review-text">
        ${review}
    </div>

    <div class="acr-bottom">

        <span class="acr-verified">
            ✔ Verified Buyer
        </span>

        <span class="acr-city">
            ${city}
        </span>

        <span class="acr-date">
            ${date}
        </span>

    </div>

</div>

`;

        }

        reviewList.innerHTML = html;

    });

})();
/*=========================================================
=  Collection / Homepage Product Ratings
=========================================================*/

(function () {

    function hash(str) {

        let h = 0;

        for (let i = 0; i < str.length; i++) {
            h = ((h << 5) - h) + str.charCodeAt(i);
            h |= 0;
        }

        return Math.abs(h);

    }

    document.addEventListener("DOMContentLoaded", function () {

        document.querySelectorAll(".ankur-grid-rating").forEach(function (box) {

            const id = box.dataset.productId;

            const seed = hash(id);

            const rating = (4.6 + (seed % 5) * 0.1).toFixed(1);

            const reviews = 25 + (seed % 180);

            let stars = "";

            for (let i = 0; i < 5; i++) {
                stars += "★";
            }

            box.innerHTML = `
                <span class="acr-grid-stars">
                    ${stars}
                </span>

                <span class="acr-grid-score">
                    ${rating}
                </span>

                <span class="acr-grid-count">
                    (${reviews})
                </span>
            `;

        });

    });

})();
/*=========================================================
Collection Rating Generator
=========================================================*/

document.addEventListener("DOMContentLoaded", function () {

    if (!window.ACR_DATA) return;

    document.querySelectorAll(".ankur-product-rating").forEach(function (box) {

        const productId = parseInt(box.dataset.productId);

        function mulberry32(seed){
            return function(){
                let t = seed += 0x6D2B79F5;
                t = Math.imul(t ^ t >>> 15, t | 1);
                t ^= t + Math.imul(t ^ t >>> 7, t | 61);
                return ((t ^ t >>> 14) >>> 0) / 4294967296;
            }
        }

        const rand = mulberry32(productId);

        const rating =
            ACR_DATA.ratings[
                Math.floor(rand() * ACR_DATA.ratings.length)
            ];

        const reviews =
            15 + Math.floor(rand() * 90);

        let stars="";

        for(let i=1;i<=5;i++){

            if(i<=rating){
                stars+="★";
            }else{
                stars+="☆";
            }

        }

        box.innerHTML=`
            <span class="acr-stars">${stars}</span>
            <span class="acr-count">(${reviews})</span>
        `;

    });

});